import { Injectable } from '@angular/core';
import { StatsigService } from '@services/statsig.service';
// TODO: Move this feature flag implementation in EnterprisePlatformFeatureFlagService

enum CONFIG_NAME {
  GROUP_HIERARCHY_ENABLED = 'ent-group-hierarchy-enabled',
}

@Injectable({ providedIn: 'root' })
export class EntGroupHierarchyConfigService {
  constructor(
    private statsigService: StatsigService,
  ) {}

  public isGroupHierarchyEnabled(): boolean {
    return this.statsigService.evaluateGate(CONFIG_NAME.GROUP_HIERARCHY_ENABLED);
  }
}
